<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-folder-success`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.342 5c.647 0 1.261.312 1.676.85L21.44 9h22.115C44.906 9 46 10.015 46 11.267v29.466C46 41.985 44.906 43 43.556 43H4.444C3.094 43 2 41.985 2 40.733V7.363C2 6.059 2.977 5 4.182 5h13.16zM42 13H6v26h36V13zm-10.293 6.707l1.414 1.414a1 1 0 010 1.415l-10 10a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.415l1.414-1.414a1 1 0 011.415 0l3.878 3.879 7.879-7.879a1 1 0 011.414 0z"/></svg>
</template>
<script>

export default {
  name: 'IconFolderSuccess',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
